import React from 'react';
import SliderComponent from './SliderComponent.jsx'
import 'mathquill/build/mathquill.css'
import 'mathquill/build/mathquill.js'
import MathQuilElement from './MathQuilElement.jsx'
import ColorPickerDot from '../color-picker/ColorPickerDot';

import SubMenu from '../menu/SubMenu.jsx';
import Menu from '../menu/Menu.jsx';
import MenuItem from '../menu/MenuItem.jsx';
import Divider from '../menu/Divider.jsx';
import PlainButton from '../common/PlainButton';
import ToolTip from '../common/ToolTip';
const BENIGN_FORMULA_STRINGS = [ 'y=', '', null, undefined, 'y' ];

class ModelFunctions extends React.Component {

    changeHandler = () => {

    }

    constructor(props) {
        super(props);
        this.debug = props.Dyn.debugDataInput; // show debug messages if &debug=3 in URL
        this.hasPlotMessage = false; // the newly re-opened panel does not yet have the plot messages yet
        this.state = {
            sliderVars: [],
            hasFormulaError: false,
            formula: '',
            formulas: [
                // formulas are in LaTeX string format, as created by MathQuill
                // See latexFormulaToNerdamer() for conversion to Nerdamer-parsable format
                {
                    formula : 'y=m\\cdot x+b',
                    arialLabel : "y equals m times x plus b"
                },
                {
                    formula : 'y=m\\cdot\\left(x-k\\right)',
                    arialLabel : "y equals m times left parenthesis, x minus k , right parenthesis"
                },
                {
                    formula : '-',
                    arialLabel : ""
                },
                {
                    formula : 'y=a\\cdot x^2',
                    arialLabel : "y equals a times x Superscript, 2, Baseline"
                },
                {
                    formula : 'y=a\\cdot(x-h)^2+k',
                    arialLabel : "y equals a times left parenthesis, x minus h, right parenthesis Superscript, 2, Baseline plus k"
                },
                {
                    formula : 'y=a\\cdot\\sqrt{x}',
                    arialLabel : "y equals a times StartRoot, x, EndRoot"
                },
                {
                    formula : 'y=k/x',
                    arialLabel : "y equals StartFraction, k over x, EndFraction"
                },
                {
                    formula : 'y=a\\cdot x^p',
                    arialLabel : "y equals a times x Superscript, p, Baseline"
                },
                {
                    formula : 'y=\\sqrt[n]{x}',
                    arialLabel : "y equals Root Index n , Start Root, x , End Root"
                },
                {
                    formula : '-',
                    arialLabel : ""
                },
                {
                    formula : 'y=a\\cdot b^x',
                    arialLabel : "y equals a times b Superscript, x, Baseline"
                },
                {
                    formula : 'y=b^{\\left(x\\cdot k\\right)}',
                    arialLabel : "y equals b Superscript, left parenthesis, x times k , right parenthesis , Baseline"
                },
                {
                    formula : 'y=a\\cdot\\log\\left(x\\right)',
                    arialLabel : "y equals a times log left parenthesis, x , right parenthesis"
                },
                {
                    formula : '-',
                    arialLabel : ""
                },
                {
                    formula : 'y=\\sin\\left(k\\cdot x\\right)',
                    arialLabel : "y equals sine left parenthesis, k times x , right parenthesis"
                },
                {
                    formula : 'y=a\\cdot\\sin(x)',
                    arialLabel : "y equals a times sine left parenthesis, k times x , right parenthesis"
                },
                {
                    formula : 'a\\cdot x+b\\cdot y=c',
                    arialLabel : "a times x plus b times y equals c"
                },
                {
                    formula : 'a\\cdot x+b\\cdot y\\ge c',
                    arialLabel : "a times x plus b times y greater or equal than c"
                },{
                    formula : 'a\\cdot x+b\\cdot y\\le c',
                    arialLabel : "a times x plus b times y greater or equal than c"
                },{
                    formula : 'y>\\left|x\\right|',
                    arialLabel : "y greater than absolute value of x"
                },{
                    formula : 'y<\\left|x\\right|',
                    arialLabel : "y greater than absolute value of x"
                }
                ],
            formulaError: '',
            warningMessage: '',
            lineColor: '',
            lineVisible: true,
            rangeX: '',
            rangeY: '',
            isExpanded : true,
            colorsArray: this.props.Dyn.plotUtil.functionCurveColors,
        }
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        if(Dyn.dataSet) {
            return Dyn.loc( str );
        } else {
            return str;
        }
    }

    /**
     * (re-)evaluate the formula string to extract the slider variable names, excluding known constants, variables, and functions
     * @param newFormulaString
     * @returns {{sliderVars: Array, formulaError: *}}
     */
    getSliderVars = (newFormulaString) => {
        let Dyn = this.props.Dyn,
            sliderVars = [],
            reservedConstants = { x:NaN, y:NaN },
            formulaObj = new Dyn.PlotFormula( newFormulaString, reservedConstants ),
            symbols = formulaObj.findUnknownSymbols(),
            errorString = formulaObj.getLastErrorString( "parseErrorsOnly" );
        if( errorString ) {
            if(BENIGN_FORMULA_STRINGS.includes(formulaObj.formulaString)) {
                errorString = '';
            } else {
                this.debug && console.log( "formula parse error {"+errorString+"}" );
            }
        } else {
            // Sort symbols based on the index of their first occurrence
            const symbolSortString = formulaObj.symbolSortString ||''; // function w/o latex commands or implicit multiply ("ax+c\cdot b"=>"a x+c b")
            symbols.sort((a, b) => {
                // Regex: '\b' matches a word boundary meaning that the symbol
                // is the whole word, not part of a word.
                // e.g. sort symbols in 'y = dc*x + c/d' => 'y', 'dc', 'x', 'c', 'd'
                const regexA = new RegExp('\\b'+`${a}`+'\\b');
                const regexB = new RegExp('\\b'+`${b}`+'\\b');

                // Use search() which returns the index of the first match or -1
                const indexA = symbolSortString.search( regexA );
                const indexB = symbolSortString.search( regexB );

                // Debugging log
                // console.log(`In '${symbolSortString}' comparing '${a}' (regex: ${regexA}, index: ${indexA}) vs '${b}' (regex: ${regexB}, index: ${indexB})`);
                // Dyn.assert( indexA >= 0 && indexB >= 0, "indexA or indexB is negative: "+indexA+" "+indexB );
                return indexA - indexB; // Sort by the index found
            });

            symbols.forEach((e) => {
                if( isNaN(e) && !sliderVars.find(v => v.name === e)) {
                    var existingVar = this.state.sliderVars.find(v => v.name === e);
                    if(existingVar) {
                        sliderVars.push(existingVar);
                    } else {
                        sliderVars.push( Dyn.FunctionUtil.makeSliderVar( e, -10, 10, 1 ));
                    }
                }
            });
        }
        return({
                formulaError: errorString,
                sliderVars: sliderVars
            });
    }

    componentDidMount = () => {
        let Dyn = this.props.Dyn;

        // initialize MathQuill formula edit handler
        let MQ = window.MathQuill.getInterface(2),
            answerSpan = this.refs.formulaBox;
        this.answerMathField = MQ.MathField(answerSpan, {
            handlers: {
                edit: () => {
                    // on change to formula editing field/answerMathField
                    let oldStateAllFunctions = this.copyAllSavedFunctions(),
                        enteredMath = this.answerMathField.latex(), // Get entered math in LaTeX format
                        sliders = this.getSliderVars(enteredMath),
                        isNewFormula = (enteredMath.length > 0 ) && (this.getSavedFormulaString().length === 0),
                        changeHint = isNewFormula ? "addFunc" : "mathField";
                    sliders.formulaString = enteredMath;
                    if(sliders.formulaError) {
                        // must delete sliderVars to avoid changing them when there is a formula error
                        delete sliders.sliderVars;
                    }
                    this.setState( sliders, () => {
                        // apply new state, even if formula errors, so that old line is removed on formula error
                        this.applyFormula( this.state, oldStateAllFunctions, true, changeHint );
                    });
                }
            }
        });

        this.answerMathField.el().querySelector('textarea').setAttribute('aria-label',this.props.Dyn.loc('Function {{index}}', {"index": this.props.no}));

        this.subscriptions = [];

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:plotFunctionMessage", ( data ) => {
            // handler for formula errors from plot: display with formula or clear error state
            if( data.id == this.props.modelFunctionId ) {
                this.setState({
                    formulaError: data.message,
                    warningMessage: data.warning,
                    rangeX: data.rangeX,
                    rangeY: data.rangeY
                }, () => {
                    // save the new ranges, so that when panel is closed then reopened we have the correct values
                    this.saveFormula( this.state, "plotFunctionMessage" );
                });
                this.hasPlotMessage = true; // #2707 until true, the re-opened panel does not have the plot messages yet
            }
        });

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:plotFunctionSelected", ( data ) => {
            // handle Fx function line selected in plot:
            // update the selection state and deselect this function if it does not match the id.
            let isIDedFunction = (data.id == this.props.modelFunctionId),
                wasSelected = this.state.formulaIsSelected,
                shouldBeSelected = (isIDedFunction && data.isSelected);
            if( isIDedFunction || wasSelected ) {
                this.setState( {
                    formulaIsSelected: shouldBeSelected
                } );
            }
        });

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:restoreFormulas", ( data ) => {
            // handle restore of model function data (all formulas), and update the plot
            this.handleRestore( data );
        });

        // set up the initial or restored answerMathField and sliders state
        if( Dyn.FunctionUtil.hasSavedState( this.props.modelFunctionId )) {
            // Get saved state using modelFunctionId and set it as current state
            const formula = Dyn.deFormulas[ this.props.modelFunctionId ];
            this.setState( formula, () => {
                this.answerMathField.latex(formula.formulaString);
            });
        } else {
            // initialize lineColor to the next available line color (user can edit)
            this.answerMathField.latex("y=");
            this.setState( {
                lineColor: Dyn.FunctionUtil.getNextFunctionColor()
            }, () => {
                // Focus the answer field
                this.answerMathField.focus();
            });
        }
        // WARNING: state changes are not complete, put further code in the setState callback above (issue #2628)
    }

    componentWillUnmount() {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }

    onSliderChange = (val, sliderVar) => {
        let oldStateAllFunctions = this.copyAllSavedFunctions();
        sliderVar.val = val.val;
        sliderVar.min = val.min;
        sliderVar.max = val.max;
        sliderVar.step = val.step;
        // apply formula using current state
        this.setState( {}, () => {
            // note: if animated or changing rapidly, set wantFastResponse to true to avoid additional delay to plot update
            this.applyFormula( this.state, oldStateAllFunctions, true, "sliderVal" );
        });
    }

    /**
     * Save and apply the current formula to the plot, with undo.
     *
     * We are careful to do nothing if nothing has changed, because updates to the Model Functions panel
     * can result in multiple calls to applyFormula(), yet we only want one undo and one plot refresh.
     *
     * Note that the listener of "modelFunctions:applyFormula" (the plot) wants the state of all model functions,
     * not just this one, because "modelFunctions:applyFormula" can change one or many things at once, e.g.
     * just the formula, just one value in a slider, or (during restore), the values of all formulas and sliders
     * for all functions.
     * @param newState {*} --  new values in format of this.state and Dyn.FunctionUtil.copyFunction().
     * @param oldState {*} -- old values, for undo, in format of Dyn.FunctionUtil.copyAllFunctions()
     * @param wantFastResponse {Boolean} -- if true, update formula without animation, for faster response time
     * @param changeHint {string} -caller's declaration of what has changed, for undo purposes
     */
    applyFormula = ( newState, oldStateAllFunctions, wantFastResponse = false, changeHint = "" ) => {
        // examine what has changed
        let mediator = this.props.Dyn.mediator,
            Dyn = this.props.Dyn;
        let oldState = oldStateAllFunctions[ this.props.modelFunctionId ] || {},
            newConstants = Dyn.FunctionUtil.getConstantsFromSliderVars( newState ),
            oldConstants = Dyn.FunctionUtil.getConstantsFromSliderVars( oldState );
        let stillNoFormula = BENIGN_FORMULA_STRINGS.includes(newState.formulaString) && BENIGN_FORMULA_STRINGS.includes(oldState.formulaString ), // don't apply any changes until we have a formula
            redundantEdit = ((changeHint==="mathField") && ( // TODO figure out why this extra call, remove this workaround --CDM 2019-05-30
                                JSON.stringify( Dyn.FunctionUtil.copyFunction( newState )) ===
                                JSON.stringify( Dyn.FunctionUtil.copyFunctionState( this.props.modelFunctionId )))),
            changedFormula = ( newState.formulaString !== oldState.formulaString ),
            changedColor = ( newState.lineColor !== oldState.lineColor ),
            changedLineVisible = ( newState.lineVisible !== oldState.lineVisible ),
            changedSliderVar = JSON.stringify( newState.sliderVars ) !== JSON.stringify( oldState.sliderVars ),
            changedConstant = JSON.stringify( newConstants ) !== JSON.stringify( oldConstants ), // does not include min/max/step changes
            isVisiblePlotChange = ( changedFormula || changedColor || changedLineVisible || changedSliderVar || changedConstant ),
            isAnyChange = (isVisiblePlotChange && !( stillNoFormula || redundantEdit)) || !this.hasPlotMessage;
        Dyn.assert( Dyn.FunctionUtil.changeHintUndoStrings[changeHint], "not a valid changeHint:" + changeHint );
        this.debug && redundantEdit && console.warn("applyFormula() redundantEdit:", redundantEdit, "isAnyChange:", isAnyChange );
        let data = {
                changeHint: changeHint,
                id: this.props.modelFunctionId,
                formulaString: newState.formulaString,
                syntax: "LaTeX",
                constants: newConstants,
                lineColor: newState.lineColor,
                lineVisible: newState.lineVisible,
                fastResponse: wantFastResponse,
                noPlotChange: ! isVisiblePlotChange,
                noUndo: (changeHint==="restore"),
                undoString: Dyn.loc( Dyn.FunctionUtil.changeHintUndoStrings[changeHint], {n:this.props.no}),
                oldStateAllFunctions: oldStateAllFunctions
            };
        // Step 1: save the new state
        this.saveFormula( newState, "applyFormula:"+changeHint );

        // Step 2: plot the function and/or create undo step for changed parameters
        // Note: if there is a change to the error state, callback to "plot:plotFunctionMessage" will update state and saveFormula again.
        let numID = ""+this.props.no+":"+this.props.modelFunctionId;
        if( isAnyChange ){
            switch( changeHint) {
            case "addFunc":
            case "removeFunc":
            case "mathField":
                this.debug && console.log( "applyFormula", changeHint, "'"+(oldState.formulaString||"")+"'", "to", "'"+newState.formulaString+"'", numID );
                break;
            case "restore":
                this.debug && console.log( "applyFormula", changeHint, data );
                break;
            case "color":
                this.debug && console.log( "applyFormula", changeHint, oldState.lineColor, "to", newState.lineColor, numID );
                break;
            case "sliderVal":
                if(changedConstant) {
                    this.debug && console.log( "applyFormula", changeHint, JSON.stringify( oldConstants ), "to", JSON.stringify( newConstants ), numID );
                } else {
                    this.debug && console.log( "applyFormula", changeHint, JSON.stringify( oldState.sliderVars ), "to", JSON.stringify( newState.sliderVars ), numID );
                } break;
            case "lineVisible":
                this.debug && console.log( "applyFormula", changeHint, oldState.lineVisible, "to", newState.lineVisible, numID );
                break;
            }
            mediator.publish( "modelFunctions:applyFormula", data );
        } else {
            // changes can come from either ModelFunctions or plot or Dyn.FunctionUtil
            // so we do nothing if change already made.
            this.debug && console.log( "applyFormula", changeHint, "no change", numID  );
        }
    }

    onFormulaChange = (e, formula) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            isExpanded : true,
        });

        this.formulaDropdown.clearOpened();

        this.answerMathField.latex(formula);
        // Focus the answer field
        this.answerMathField.focus();
    }

    handleClose = () => {
        let Dyn = this.props.Dyn,
            mediator = Dyn.mediator,
            oldStateAllFunctions = this.copyAllSavedFunctions(),
            changeHint = "removeFunc",
            undoString = Dyn.loc( Dyn.FunctionUtil.changeHintUndoStrings[changeHint], {n:this.props.no});
        // remove with this ID from panel (ModelFunctionsWrapper handleModelFunctionEleClose())
        this.props.handleClose(this.props.modelFunctionId);
        // remove formula with this ID from saved formulas
        this.deleteSavedFormula();
        // remove curve with this ID from plotview, and save undo state
        mediator.publish( "modelFunctions:removeFormula", {
            id:this.props.modelFunctionId,
            changeHint:changeHint,
            undoString:undoString,
            oldStateAllFunctions:oldStateAllFunctions } );
    }

    handleRestore = (data) => {
        // handle restore or undo of model function data (all formulas), which is initiated by the plot.
        // NOTE: plotFunctionElement.restore() has just updated the saved formula similar to this.saveFormula()
        // console.log( "ModelFunctions.handleRestore()", ""+this.props.no+":"+this.props.modelFunctionId );
        let mediator = this.props.Dyn.mediator,
            Dyn = this.props.Dyn,
            newState,
            oldStateAllFunctions = data.oldStateAllFunctions || {};
        if( Dyn.FunctionUtil.hasSavedState( this.props.modelFunctionId ) ) {
            // get our new state from the saved formula (which is newly restored)
            newState = this.restoreSavedFormula();
            this.setState( newState, () => {
                // update plot without undo
                if( this.state.formulaString.length === 0 && this.state.sliderVars.length === 0 ) {
                    mediator.publish( "modelFunctions:removeFormula", { id: this.props.modelFunctionId, noUndo: true } );
                } else {
                    this.applyFormula( this.state, oldStateAllFunctions, true, "restore" );
                }
                this.answerMathField.latex( newState.formulaString ); // update visible formula?
            } );
        }
    }

    // toggleExampleFormulas = () => {
    //     this.setState({
    //         showFormulas: !this.state.showFormulas
    //     });
    // }

    onColorChange = (color) => {
        if( color && color.hex ) {
            let oldStateAllFunctions = this.copyAllSavedFunctions();
            this.setState({lineColor: color.hex}, () => {
                if( this.state.formulaString ){
                    this.applyFormula(this.state, oldStateAllFunctions, false, "color");
                }
            });
        }
    }

    onLineVisibleChange = (isLineVisible) => {
        let oldStateAllFunctions = this.copyAllSavedFunctions();
        this.setState({ lineVisible: Boolean(isLineVisible), isExpanded: isLineVisible }, () => {
            if( this.state.formulaString ){
                this.applyFormula(this.state, oldStateAllFunctions, true, "lineVisible");
            }
        });
    }

    // // To hide the formula list when press on esc
    // _onKeyDown = (e) => {
    //     if (e.keyCode === 27) {
    //         this.setState({
    //             showFormulas: false
    //         });
    //     }
    // }

    handleToggleBtn = () => {
        this.setState({
            isExpanded : !this.state.isExpanded
        });
    }

    displayMathQuilString = () => {
        if(this.state.formulaString)
            return <MathQuilElement value={this.state.formulaString}/>
        else
            return '';
    }

    render = () => {
        const Dyn = this.props.Dyn;

        var attributeXRow = null;
        if(this.props.xAttribute) {
            attributeXRow = <p className='tde-px-2'><span className="tde-truncate">x = {this.props.xAttribute}</span>
                { this.state.rangeX &&
                    <span className="tde-truncate tde-pl-4">[{this.state.rangeX}]</span>
                }
            </p>
        } else {
            attributeXRow = <p className='tde-err-msg-text-wrapper'><span>{this.getLoc('Place a numerical attribute on the X-Axis')}</span></p>
        }
        var attributeYRow = null;
        if(this.props.yAttribute) {
            attributeYRow = <p className='tde-px-2'><span className="tde-truncate">y = {this.props.yAttribute}</span>
                { this.state.rangeY &&
                    <span className={ this.state.warningMessage ? "tde-truncate tde-err-msg-text-color tde-pl-4" : "tde-pl-4" }>[{this.state.rangeY}]</span>
                }
            </p>
        } else {
            attributeYRow = <p className='tde-err-msg-text-wrapper'><span>{this.getLoc('Place a numerical attribute on the Y-Axis')}</span></p>
        }

        return (
            <div aria-label={this.props.Dyn.loc('Function {{index}}', {"index": this.props.no})} tabIndex="0" className={'tde-model-functions tde-divider-bottom ' + (this.state.formulaIsSelected? ' tde-selected': '') + (!this.state.isExpanded ? ' tde-fn-collapse' :'')}>
                <div className={"tde-row tde-d-flex tde-justify-space-between tde-model-function-header tde-model-header-bg tde-flex-items-center tde-pr-2 tde-pl-2"}>
                    <div className='tde-d-flex tde-flex-items-center'>
                        <PlainButton className="tde-filter-close" onClick={() => this.onLineVisibleChange( !this.state.lineVisible ) } aria-label={this.props.Dyn.loc('Show/Hide Function Line {{index}}', {"index": this.props.no})}>
                            <i style={{width:'21px'}} className={`tde-i ${ this.state.lineVisible ? 'tde-i-eye' : 'tde-i-eye-slash'} tde-font-weight-regular tde-primary-text-color`}></i>
                        </PlainButton>
                        <div className="tde-font-weight-bold tde-formula-number tde-pt-0 tde-pl-2">
                            <span>{this.props.no}</span>
                        </div>
                        {this.state.lineColor &&
                            <ColorPickerDot color={this.state.lineColor}
                                colorsArray={this.state.colorsArray}
                                size={16}
                                style={{display: 'inline-block'}}
                                onChange={this.onColorChange}
                                Dyn={Dyn}
                                borderColor={'#fff'}
                            />
                        }
                    </div>
                    <div>
                        <ToolTip tip={this.props.Dyn.loc('Remove Function {{index}}', {"index": this.props.no})} Dyn={this.props.Dyn}>
                        <PlainButton className="tde-filter-close" onClick={this.handleClose} aria-label={this.props.Dyn.loc('Remove Function {{index}}', {"index": this.props.no})}>
                            <i className="tde-i tde-i-trash tde-pr-1 tde-ml-1"></i>
                        </PlainButton>
                        </ToolTip>
                        <PlainButton className="tde-p-0 tde-ml-1" onClick={this.handleToggleBtn}
                            aria-label={this.props.Dyn.loc(this.state.isExpanded ? 'Collapse Function {{index}}' : 'Expand Function {{index}}', {"index": this.props.no})}>
                            {this.state.isExpanded ? <i className="tde-i tde-i-next tde-font-weight-bold" style={{transform:'rotate(90deg)',fontSize:'12px'}}></i>
                            : <i className="tde-i tde-i-next tde-font-weight-bold"  style={{transform:'rotate(270deg)',fontSize:'12px'}}></i>}
                        </PlainButton>
                    </div>
                </div>

                <div className={"tde-row tde-my-3 tde-px-2"}>
                    <div className="tde-d-flex tde-align-center">
                        <div className="tde-var-name tde-s1 tde-font-weight-semibold">
                            { Dyn.PlotFormula.enableInequalities() ? '':'y =' }
                        </div>
                        <div className='tde-flex-1'>
                        <ToolTip tip={this.displayMathQuilString()} Dyn={this.props.Dyn}>
                        <div className="tde-input tde-d-flex tde-flex-1 tde-input-border">
                            <span ref="formulaBox" className="tde-input"></span>
                            {/* { this.state.showFormulas &&
                                <ul tabIndex="0" ref="formulaList" className="tde-example-formulas">
                                    { this.state.formulas.map((formula, i) => {
                                        if(formula === '-') {
                                            return <li key={i} className="tde-seperator"></li>
                                        } else {
                                            return <li tabIndex="0" key={i} onClick={() => this.onFormulaChange(formula)}>
                                                    <MathQuilElement tabIndex="0" value={formula}/>
                                            </li>
                                        }
                                    }) }
                                </ul>
                            } */}
                            <Menu direction="horizontal"
                                ref={ele => this.formulaDropdown = ele}
                                className="tde-formula-drop-btn">
                                <SubMenu
                                    container={this.props.toolsContainer}
                                    id="1"
                                    data-level="1"
                                    inputType="dropdown"
                                    popupClassName="tde-formula-dropdown-menu"
                                    label={<div className="tde-formula-drop-arrow" role="button"
                                    aria-label={this.getLoc('Select Predefined Functions')}>
                                        <i className="tde-i tde-i-selectbox-arrow"></i>
                                    </div>}
                                    reducecasecardwidth={this.props.reduceCaseCardWidth?'true':'false'}>
                                    { this.state.formulas.map((obj, i) => {
                                        if(obj.formula === '-') {
                                            return <Divider id={"1_" + i} key={i}></Divider>
                                        } else {
                                            return <MenuItem id={"1_" + i} key={i} aria-label={obj.arialLabel} data-level="2" onClick={(e) => this.onFormulaChange(e, obj.formula)}>
                                                <div className={`tde-model-formula-item `+ (obj.formula === this.state.formulaString ? "tde-selected" : "")}> <MathQuilElement value={obj.formula}/> </div>
                                            </MenuItem>
                                        }
                                    }) }
                                </SubMenu>
                            </Menu>
                        </div>
                        </ToolTip>
                        </div>
                    </div>
                </div>

                <div className={"tde-row"}>
                    {this.state.isExpanded &&
                    <>
                        <div className={"tde-row tde-px-2"}>
                            <div className="tde-my-2 tde-s1 tde-axis-values tde-font-weight-regular">
                                {attributeXRow}
                            </div>
                            <div className="tde-my-2 tde-s1 tde-axis-values tde-font-weight-regular">
                                {attributeYRow}
                            </div>
                        </div>

                        {this.state.sliderVars.map((sliderVar, i) => {
                            return <div className={"tde-row tde-mt-1 tde-px-2"} key={i}>
                                <div className="tde-slider tde-pl-2">
                                    <SliderComponent getLoc={this.getLoc} Dyn={this.props.Dyn} onChange={(val) => this.onSliderChange(val, sliderVar)} min={sliderVar.min} max={sliderVar.max} step={sliderVar.step} val={sliderVar.val} name={sliderVar.name} reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                                </div>
                            </div>
                        }) }

                        { this.state.formulaError &&
                            <div className="tde-err-msg-text-wrapper tde-mx-2 tde-d-flex tde-mt-n1 tde-mb-1">
                                <span className="tde-s1 tde-font-weight-regular  tde-flex-1 tde-pr-2">{this.state.formulaError}</span>
                            </div>
                        }
                        { !this.state.formulaError && this.state.warningMessage &&
                            <div className="tde-warning-wrapper tde-pt-2 tde-mx-2 tde-pl-2 tde-pb-3 tde-d-flex tde-mt-n1 tde-mb-1">
                                <i className="tde-i tde-i-exclamation-fill tde-mt-1 tde-mr-2"></i>
                                <span className="tde-font-weight-regular tde-flex-1 tde-pr-2">{this.getLoc(this.state.warningMessage)}</span>
                            </div>
                        }
                    </>}
                </div>

                {/* { this.state.showFormulas &&
                    <div onClick={this.toggleExampleFormulas} style={{position: 'absolute', top: '40px', bottom: 0, width: '100%', zIndex:'10'}}></div>
                } */}
            </div>
        )
    }

    // Save current state into Dyn.deFormulas
    saveFormula = ( newState, saveHint ) => {
        let Dyn = this.props.Dyn;
        this.debug && console.log( "saveFormula", saveHint, this.state.formulaString, newState, this.props.modelFunctionId  );
        Dyn.FunctionUtil.saveFunctionState( this.props.modelFunctionId, newState );
    }

    // Delete current state from Dyn.deFormulas
    deleteSavedFormula = () => {
        let Dyn = this.props.Dyn;
        Dyn.FunctionUtil.deleteFunctionState( this.props.modelFunctionId );
        return( { formulaString:"", sliderVars:[] } ); // new state
    };

    // restore the saved formula
    restoreSavedFormula = () => {
        let Dyn = this.props.Dyn,
            newState = Dyn.FunctionUtil.copyFunctionState( this.props.modelFunctionId );

        // make sure that certain fields have defaults
        newState.formulaString  = newState.formulaString || "";
        newState.sliderVars     = newState.sliderVars    || [];
        newState.rangeX         = newState.rangeX || "";
        newState.rangeY         = newState.rangeY || "";
        newState.warningMessage = newState.warningMessage || "";

        if( Dyn.FunctionUtil.hasSavedState( this.props.modelFunctionId )) {
            this.debug && console.log( "restoreSavedFormula", this.props.modelFunctionId, this.state.formulaString, newState.formulaString, newState.sliderVars, newState.rangeX, newState.rangeY );
        } else {
            this.debug && console.log( "restoreSavedFormula clear existing:", this.props.modelFunctionId, this.state.formulaString );
        }
        return newState;
    };

    // copy the saved formula for undo
    // copySavedFormula = () => {
    //     let Dyn = this.props.Dyn;
    //     return Dyn.FunctionUtil.copyFunctionState( this.props.modelFunctionId );
    // };
    copyAllSavedFunctions = () => {
        let Dyn = this.props.Dyn;
        return Dyn.FunctionUtil.copyAllFunctions();
    };
    getSavedFormulaString = () => {
        let Dyn = this.props.Dyn,
            savedState = Dyn.FunctionUtil.getSavedState( this.props.modelFunctionId );
        return( (savedState && savedState.formulaString) || "" ); // return empty string if it does not exist.
    };
}

export default ModelFunctions;
